import moment from 'moment'
import EnvUtils from "../../utils/EnvUtils";
export default class SimpleTableHelpers {
  // Rendering
  static render(row, col) {
    let rawValue = row[col.field]
    if (typeof col.renderer === "function") {
      return col.renderer.call(this, rawValue, row)
    }
    switch(col.format) {
      case "number":
        return this.renderNumber(rawValue, row);
      case "bool":
        return this.renderBool(rawValue, row)
      case "boolReverted":
        return this.renderBool(!rawValue, row)
      case "dateTime":
        return this.renderDateTime(rawValue, row)
      case "diffFromNow":
        return this.renderDiffFromNow(rawValue, row)
      case "ownerEmail":
        return this.renderOwnerEmail(rawValue, row)
      case "emailVerificationLink":
        return this.renderEmailVerificationLink(rawValue, row)
      case "assignedDevice":
        return rawValue ? rawValue : "- not assigned -"
      case "listCount":
        return Array.isArray(rawValue) ? rawValue.length : "&nbsp;"
      case "labels":
        return Array.isArray(rawValue) ? this.renderLabels(rawValue) : "&nbsp;"
      case "usage":
        return this.renderUsage(rawValue, row)
      case "lastContact":
        return this.renderLastContact(rawValue, row)
      default:
        return this.renderDefault(rawValue, row)
    }
  }
  static renderDefault(rawValue) {
    return rawValue == null || rawValue === "" ? "&nbsp;" : rawValue
  }
  static renderNumber(rawValue) {
    return `<div style="text-align: right;">${rawValue}</div>`
  }
  static renderBool(rawValue) {
    return rawValue === null ? 'UNKNOWN' : rawValue === true ? 'Yes' : 'No'
  }
  static renderDateTime(rawValue) {
    let dateValue = tryParseDate(rawValue)
    if (dateValue) {
      return moment(dateValue).format('DD/MM/YYYY HH:mm:ss')
    }
    return "&nbsp;"
  }
  static renderDiffFromNow(rawValue) {
    if ((rawValue || "") === "") {
      return "&nbsp;"
    }
    return moment.duration(moment().diff(rawValue)).humanize() + " ago"
  }
  static renderOwnerEmail(rawValue) {
    if (!rawValue) {
      return "- unowned -"
    }
    return rawValue
  }
  static renderEmailVerificationLink(rawValue) {
    if (!rawValue) return "&nbsp;"
    let regLinkBase = EnvUtils.isdev() ? 'https://register.dev.caite.io' : 'https://register.caite.io'
    let link = `https://locaite.page.link/?link=${regLinkBase}/verify/${rawValue}&apn=io.caite.locaite.app&ibi=io.caite.locaite.app&efr=1`
    return `${rawValue}&nbsp; <a style="float:right;" target="_blank" href="${link}">⇉</a>`
  }
  static renderLabels(rawValue) {
    return `<span class="sticker blue">` + rawValue.join(`</span><span class="sticker blue">`) + `</span>`
  }
  static renderUsage(rawValue, row) {
    if (row.SIMProvider != "RITESIM" && row.SIMProvider != "RITESIMEE" && row.SIMProvider != 'EE') {
      return row.SIMProvider
    }
    let dataMB = ((row.DataUsage || 0) / (1024 * 1024)).toFixed(2)
    return `${dataMB}MB</div>, SMS:${row.SMSMOUsage || 0}/${row.SMSMTUsage || 0}, Voice:${row.VoiceMOUsage || 0}/${row.VoiceMTUsage || 0} sec.`
  }

  static renderLastContact(rawValue) {
    if ((rawValue || "") === "") {
      return "&nbsp;"
    }
    let inMinutes = moment.duration(moment().diff(rawValue)).asMinutes()
    if (inMinutes > 30) {
      return '&nbsp;'
    }
    if (inMinutes > 10) {
      return `<div style="text-align:center"><i class="orange wifi icon"></i></div>`
    }
    return `<div style="text-align:center"><i class="green wifi icon"></i></div>`
  }


  // Sorting
  static sort(col, reverse) {
    switch(col.format) {
      case "number":
        return this.sortNumeric(col.field, reverse)
      case "dateTime":
      case "diffFromNow":
        return this.sortDateTime(col.field, reverse)
      default:
        return this.sortString(col.field, reverse)
    }
  }
  static sortString(field, reverse) {
    return function(a, b) {
      let sortField1 = '' + (reverse ? b[field] : a[field])
      let sortField2 = '' + (reverse ? a[field] : b[field])
      return sortField1.localeCompare(sortField2)
    }
  }
  static sortNumeric(field, reverse) {
    return function(a, b) {
      let sortField1 = '' + (reverse ? a[field] : b[field])
      let sortField2 = '' + (reverse ? b[field] : a[field])
      return sortField1 - sortField2
    }
  }

  static sortDateTime(field, reverse) {
    return function(a, b) {
      let sortField1 = '' + (reverse ? a[field] : b[field])
      let sortField2 = '' + (reverse ? b[field] : a[field])
      let parsed1 = tryParseDate(sortField1)
      let parsed2 = tryParseDate(sortField2)
      return (parsed1 || -1) - (parsed2 - 1)
    }
  }
}


function tryParseDate(val) {
  if (Object.prototype.toString.call(val) === '[object Date]') {
    return val
  }
  let parsed
  try {
    parsed = Date.parse(val)
  } catch (err) {
    parsed = null
  }
  return parsed
}
